import { ACTION_LOG_TYPE } from "Common/dictionaries/actionLogType";
import { SORT_ORDER } from "Common/dictionaries/sortOrder";
import DataGridBase, { DateTimeCell, TextCell } from "Components/dataGridBase";
import { Column, HeaderFilter, Lookup } from "devextreme-react/data-grid";
import compact from "lodash/compact";
import map from "lodash/map";
import React, { useEffect, useMemo } from "react";
import locale from "./actionGrid.locale";
export default function ActionGrid(props) {
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    const loadUrl = useMemo(() => props.loadUrl(props.type), [props.loadUrl, props.type]);
    const actionLogEventTypeColumnChildren = useMemo(() => {
        if (props.actionLogEventTypeDictionary &&
            props.type &&
            props.type in props.actionLogEventTypeDictionary) {
            const eventTypes = props.actionLogEventTypeDictionary[props.type];
            return [
                React.createElement(Lookup, { key: "lookup", dataSource: eventTypes, valueExpr: "Id", displayExpr: "Name" }),
                React.createElement(HeaderFilter, { key: "headerFilter", dataSource: map(eventTypes, e => ({
                        text: e.Name,
                        value: e.Id
                    })) })
            ];
        }
        return undefined;
    }, [props.actionLogEventTypeDictionary, props.type]);
    const projectColumnChildren = useMemo(() => {
        if (!props.actionLogProjects)
            return undefined;
        const dataSource = map(compact(props.actionLogProjects), e => ({
            text: e,
            value: e
        }));
        return [
            React.createElement(Lookup, { key: "lookup", dataSource: dataSource, valueExpr: "value", displayExpr: "text" }),
            React.createElement(HeaderFilter, { key: "headerFilter", dataSource: dataSource })
        ];
    }, [props.actionLogProjects]);
    const userCreatedColumnChildren = useMemo(() => {
        if (!props.actionLogUsers)
            return undefined;
        const dataSource = map(compact(props.actionLogUsers), e => ({
            text: e,
            value: e
        }));
        return [
            React.createElement(Lookup, { key: "lookup", dataSource: dataSource, valueExpr: "value", displayExpr: "text" }),
            React.createElement(HeaderFilter, { key: "headerFilter", dataSource: dataSource })
        ];
    }, [props.actionLogUsers]);
    const filterBuilderFields = useMemo(() => {
        const fields = [
            {
                dataField: "Created",
                dataType: "date",
                caption: locale.CREATED
            },
            {
                dataField: "UserCreatedName",
                dataType: "number",
                caption: locale.USER_NAME
            },
            {
                dataField: "ActionEventType",
                dataType: "number",
                caption: locale.ACTION_TYPE
            },
            {
                dataField: "Source",
                dataType: "string",
                caption: locale.SOURCE
            },
            {
                dataField: "Event",
                dataType: "string",
                caption: locale.RECORD
            }
        ];
        if (props.type === ACTION_LOG_TYPE.USER_ACTIONS)
            fields.push({
                dataField: "ProjectName",
                dataType: "number",
                caption: locale.PROJECT
            });
        return fields;
    }, [props.type, locale]);
    const gridComponent = useMemo(() => (projectColumnChildren || props.type !== ACTION_LOG_TYPE.USER_ACTIONS) &&
        actionLogEventTypeColumnChildren &&
        userCreatedColumnChildren ? (React.createElement(DataGridBase, { className: props.className, onHasDataChanged: props.onHasDataChanged, gridRef: props.gridRef, loadUrl: loadUrl, key: props.type || -1, remoteOperations: true, filterBuilderFields: filterBuilderFields },
        React.createElement(Column, { allowHeaderFiltering: false, dataField: "Created", dataType: "date", caption: locale.CREATED, cellRender: DateTimeCell, sortOrder: SORT_ORDER.DESC, editorOptions: { placeholder: locale.FILTER_PLACEHOLDER }, width: 160 }),
        React.createElement(Column, { dataField: "UserCreatedName", dataType: "number", alignment: "left", caption: locale.USER_NAME, cellRender: TextCell, editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }, userCreatedColumnChildren),
        React.createElement(Column, { dataField: "ActionEventType", dataType: "number", alignment: "left", caption: locale.ACTION_TYPE, cellRender: TextCell, editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }, actionLogEventTypeColumnChildren),
        React.createElement(Column, { allowHeaderFiltering: false, dataField: "Source", dataType: "string", caption: locale.SOURCE, cellRender: TextCell, width: props.type === ACTION_LOG_TYPE.USER_ACTIONS ? 160 : undefined, editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }),
        React.createElement(Column, { allowHeaderFiltering: false, dataField: "Event", key: "Event", dataType: "string", caption: locale.RECORD, cellRender: TextCell, width: props.type === ACTION_LOG_TYPE.USER_ACTIONS ? "25%" : "35%", editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }),
        props.type === ACTION_LOG_TYPE.USER_ACTIONS && (React.createElement(Column, { dataField: "ProjectName", key: "ProjectName", dataType: "number", alignment: "left", caption: locale.PROJECT, cellRender: TextCell, editorOptions: { placeholder: locale.FILTER_PLACEHOLDER } }, projectColumnChildren)))) : null, [
        loadUrl,
        props.type,
        actionLogEventTypeColumnChildren,
        projectColumnChildren,
        userCreatedColumnChildren
    ]);
    return gridComponent;
}
